import { render } from "./updateGamme.vue?vue&type=template&id=b824d0a0&scoped=true"
import script from "./updateGamme.vue?vue&type=script&lang=js"
export * from "./updateGamme.vue?vue&type=script&lang=js"

import "./updateGamme.vue?vue&type=style&index=0&id=b824d0a0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b824d0a0"]])

export default __exports__